import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import { WisdomChatRenameModalContent } from '@modules/oracle/components/WisdomChatRenameModalContent';
import { WisdomLogoIcon } from '@modules/oracle/components/WisdomLogoIcon';
import { useOracleSearchStore } from '@modules/oracle/store/oracleSearchStore';
import { EditRounded } from '@mui/icons-material';
import { IconButton, Stack, Typography, TypographyProps } from '@mui/material';
import dayjs from 'dayjs';

interface WisdomChatDetailsProps {
  titleVariant?: TypographyProps['variant'];
  logoFontSize?: string;
  shouldShowRenameButton?: boolean;
}

export const WisdomChatDetails = ({
  titleVariant = 'subtitle2',
  logoFontSize = '36px',
  shouldShowRenameButton = false,
}: WisdomChatDetailsProps) => {
  const chat = useOracleSearchStore(({ data }) => data.chat);
  const { openModal } = useMuiModalContext();

  const openRenameChatModal = () => {
    if (!chat) {
      return;
    }

    openModal({
      contentComponent: () => <WisdomChatRenameModalContent chat={chat} />,
      modalProps: {
        maxWidth: 'sm',
        fullWidth: true,
        PaperProps: {
          elevation: 3,
        },
      },
    });
  };

  if (!chat) {
    return null;
  }

  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <WisdomLogoIcon sx={{ fontSize: logoFontSize }} />
      <Stack>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Typography variant={titleVariant}>{chat.title}</Typography>
          {shouldShowRenameButton && (
            <IconButton size="small" onClick={openRenameChatModal}>
              <EditRounded
                fontSize="small"
                sx={{
                  color: 'text.secondary',
                }}
              />
            </IconButton>
          )}
        </Stack>
        <Typography variant="caption" color="text.secondary">
          Wisdom Chat • {chat.createdBy.firstName} •{' '}
          {dayjs.unix(chat.updatedAt).fromNow()}
        </Typography>
      </Stack>
    </Stack>
  );
};
